define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerTypeModel = /** @class */ (function () {
        function CustomerTypeModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.SystemKey = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerTypeModel.Mapping, self);
            }
        }
        CustomerTypeModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerTypeModel(options.data);
            }
        };
        return CustomerTypeModel;
    }());
    return CustomerTypeModel;
});
//# sourceMappingURL=CustomerTypeModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerTypeModel.js
// module id = 237
// module chunks = 2